<template>
  <!-- 我的报名。报名界面，二维码界面 -->
  <div class="intent">
    <Banner :list="bannerList" :height="186" :showBtn="false" class="head-banner"></Banner>


    <div class="intent-block urge-block" v-for="item in userList">
      <div class="qrcode-block">
        <div class="name">{{item.username}}</div>
        <div class="qrcode" ref="qrcode" />
      </div>

    </div>

    <div v-if="userList && userList.length > 0" class="verify" @click="handleVerify">
      查看核销记录 >>
    </div>

    <div class="intent-block urge-block">
      <div class="intent-title">
        <span><img src="@/../static/title_left.png"></span>
        参赛者登录
        <span><img src="@/../static/title_right.png"></span>
      </div>
      <div class="control-block row">
        <div class="control-label">
          手机号：
        </div>
        <div class="control-input">
          <input type="text" v-validate="'required'|'phone'" name="username" class="form-control" placeholder="请输入手机号"
            v-model="phone" />
          <span v-show="errors.has('phone')" class="error-text">{{errors.first('phone')}}</span>
        </div>
      </div>
      <div class="control-block row">
        <div class="control-label">
          证件号后4位：
        </div>
        <div class="control-input">
          <input type="text" name="code" v-validate="'required|code'" class="form-control" placeholder="请输入证件号"
            v-model="idcode" />

          <span v-show="errors.has('code')" class="error-text">{{errors.first('code')}}</span>

        </div>
      </div>



      <van-loading v-if="isLoading" size="20">验证中...</van-loading>
      <div class="control-block row button-block">
        <button type="button" :disabled="isLoading" class="button button-primary" @click="handleLogin">{{userList?'增加':'登录'}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2';
  import {
    MessageBox,
    Toast
  } from "mint-ui"
  import wx from "weixin-js-sdk"
  import Banner from "../components/MobileBanner"
  export default {
    components: {
      Banner
    },
    data() {
      return {
        isLoading: false,
        bannerList: [{
          mobileImageUrl: "/abc/static/banner.png"
        }],
        code: '',
        openId: '',
        wechatReady: false,
        phone: '',
        idcode: '',
        userList: undefined,
        appId:''
      }
    },
    mounted() {
      this.openId = localStorage.getItem("openId")
      this.getWechatSign();
      wx.ready(function() {

      });
      wx.error(function(res) {
        console.log(res)
        MessageBox.alert("微信环境初始化失败");
      });

      document.title = "参赛者登录";
    },
    methods: {
      getWechatSign: function() {
        const self = this;
        let url = location.href;
        console.log("url" + url);
        let encodeUrl = encodeURIComponent(url);
        this.$http.get("/bicycle/inter/getWechatSign?url=" + encodeUrl).then(function(res) {
          if (res.data.status != 200) {
            MessageBox.alert(res.data.errorMsg);
          } else {
            let e = res.data.data;

            if (self.$route.query.code) {
              self.code = self.$route.query.code;
              self.appId = e.appId
              wx.config({
                debug: false, // 关闭调试模式
                appId: e.appId, // 必填，公众号的唯一标识
                timestamp: e.timestamp, // 必填，生成签名的时间戳
                nonceStr: e.nonceStr, // 必填，生成签名的随机串
                signature: e.signature, // 必填，签名
                jsApiList: [
                  'updateAppMessageShareData', 'onMenuShareTimeline'
                ], // 必填
                openTagList: ['wx-open-subscribe']
              });

              //获取openId
              if (!self.openId) {
                self.getOpenId();
              } else {
                self.wechatReady = true;
                self.getMyIntent()
              }


              history.pushState({}, document.title, url);
            } else {
              let currentUrl = location.href;
              let redirectUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + e.appId +
                "&redirect_uri=" + encodeURIComponent(currentUrl) +
                "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
              window.location.href = redirectUrl;
            }
          }
        }).catch(function(error) {
          console.log(error)
        });
      },
      getOpenId: function() {
        const self = this;
        self.$http.get("/bicycle/inter/getOpenId?code=" + self.code).then(function(res) {
          if (res.data.status != 200) {
            if(res.data.errorMsg.indexOf("Code已过期") >= 0){
              let currentUrl = location.origin + location.pathname;
              let redirectUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + self.appId +
                "&redirect_uri=" + encodeURIComponent(currentUrl) +
                "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
              window.location.href = redirectUrl;
              return
            }
            MessageBox.alert(res.data.errorMsg);
          } else {
            self.openId = res.data.data;
            self.wechatReady = true;
            self.getMyIntent(); //获取我的商户信息
          }
        }).catch(function(error) {
          console.log(error)
        });
      },
      getMyIntent() {
        const self = this
        this.$http.post("/bicycle/inter/getIntentUsers", {
          openId: this.openId
        }).then(function(res) {
          if (res.data.status == 200 && res.data.data.length > 0) {
            self.userList = res.data.data
            self.generateQrcode()
          }

        }).catch(function(error) {
          console.log(error)
        })
      },
      handleLogin() {
        const params = {
          openId: this.openId,
          phone: this.phone,
          idcode: this.idcode
        }
        try {
          const self = this
          this.$validator.validate().then(valid => {
            if (valid) {
              self.isLoading = true

              self.$http.post("/bicycle/inter/validIntent", params).then(function(res) {
                self.isLoading = false
                if (res.data.status == 200) {
                  self.userList = res.data.data
                  self.generateQrcode()
                }
              }).catch(function(err) {
                console.log(err)
                self.isLoading = false
              })
            }
          })
        } catch (err) {

        }
      },
      handleVerify(){
        this.$router.push({path: "/verifyList"})
      },
      generateQrcode() {
        this.$nextTick(() => {
          for (let i = 0; i < this.$refs.qrcode.length; i++) {
            this.$refs.qrcode[i].innerHTML = ''
            console.log( this.$refs.qrcode[i])
            new QRCode(this.$refs.qrcode[i], {
              text: 'INTENT:' + this.userList[i].userId, // 二维码内容
              width: 128, // 宽度(像素)
              height: 128, // 高度(像素)
              colorDark: '#000000', // 二维码颜色
              colorLight: '#ffffff', // 背景颜色
              correctLevel: QRCode.CorrectLevel.H // 容错级别
            });

          }
          console.log(this.$refs.qrcode)
        })
      }
    }
  }
</script>

<style scoped>
  .verify{
    text-align: center;
    padding: 12px;
    color: #137cd7;
    font-size: 14px;
  }
  .qrcode-block{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .name{
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.1em;
    margin-bottom: 12px;
  }
  .step-img {
    padding: 27px 42px;
  }

  .step-img img {
    width: 100%;
  }

  .intent-title {
    text-align: center;
    color: rgb(19, 124, 215);
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 25px;
  }

  .control-block {
    margin-top: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .control-label {
    color: rgb(102, 102, 102);
    font-size: 15px;
    float: left;
    width: 30%;
  }

  .control-input {
    width: 70%;
  }

  .form-control {
    border: 1px solid rgb(229, 229, 229);
    border-radius: 6px;
    height: 38px;
    color: rgb(51, 51, 51);
    font-size: 15px;
    padding: 0 14px;
    width: 100%;
    background: #fff;
  }

  .radio-inline {
    padding: 0 0;
    display: flex;
    align-items: center;
  }

  .radio-row {
    padding: 0 0;
    display: flex;
    flex-direction: column;
    height: auto;
    padding: 7px 0;
  }

  .radio-row label {
    margin-left: 14px;
    padding: 7px 0;
  }

  .radio-inline input {
    margin-left: 14px;
  }

  .add {
    justify-content: start;
    margin-top: 35px
  }

  input,
  select,
  textarea {
    box-sizing: border-box;
  }

  textarea {
    min-height: 60px;
  }

  .button-block {
    margin-top: 35px;
  }

  .button-add:active {
    opacity: 0.7;
  }

  .order-height {
    height: 74px;
  }

  .order-block {
    background-color: #FFF;
    height: 64px;
    box-shadow: 2px -2px 5px #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }


  .error-text {
    color: red;
    padding-left: 12px;
  }

  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }

  input:-moz-placeholder,
  textarea:-moz-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }

  input::-moz-placeholder,
  textarea::-moz-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }

  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/MobileMyIntent.vue